module.exports = __webpack_public_path__ + "a6d115ed8dc4c9540cffc35c28efdabb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/icons/pdf-file-format-symbol.svg
// module id = 1173
// module chunks = 0